import React from 'react';
import MyText from './MyText';

export default function TextArea(props){
    return(
        <div style={{...styles.container, ...props.containerStyle}}>
            <MyText style={{...styles.label, ...props.labelStyle}}>{props.label}</MyText>
            <textarea type="text" value={props.value} onChange={props.onChange} style={{...styles.textarea, ...props.inputStyle}}/>
        </div>
    );
};
const styles = {
    container:{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    label:{
        fontSize: '1.2rem',
    },
    textarea:{
        // width: '100%',
        height: 100,
        borderRadius: 10,
        border: 'none',
        padding: '0.5rem 1rem',
        boxShadow: '0px 4px 4px 0px #0000000D',
        resize: 'none',
    }
}